export enum SyncJobStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  FAILED = 'failed',
  SUCCESS = 'success',
  PARTIALLY_FAILED = 'partially_failed',
  SKIPPED = 'skipped',
}
